import { IAggregationsParams } from "@multiweb/clients/dataReader";
import { EMPTY_ARRAY, isArrayShallowEqual } from "@multiweb/reactUtils";
import { MutableTypedObject } from "@multiweb/types/react";
import { NAME } from "./constants";
import { AggregationResult, AggregationRowKey, Column, ColumnDefinition, Filter, FormattedAggregationResults } from "./types";

/**
 * Vytvoří sloupec podle definice.
 * @param columnDefinition Definice sloupce.
 */
export const createColumn = ({ key, attributeName, columnType, width, format }: ColumnDefinition): Column => ({
    key,
    attributeName: attributeName ?? null,
    columnType,
    width,
    format: format ?? null,
    aggregationFunction: null,
    aggregationResult: null,
});

/**
 * Vytvoří klíč pro identifikaci načítání výsledku agregační funkce.
 * @param aggregationRowKey Klíč agregačního řádku, pro který probíhá načítání.
 * @param columnKey Klíč sloupce, pro který probíhá načítání. Nezadává se, pokud načítání probíhá pro všechny sloupce agregačního řádku.
 */
export const createAggregationResultFetchingKey = (aggregationRowKey: AggregationRowKey, columnKey?: string) => `${NAME}/${aggregationRowKey}/${columnKey}`;

/**
 * Porovná obsah filtrů pro agregační řádek. Vrací true pokud je obsah shodný.
 * @param firstFilter První filtr k porovnání.
 * @param secondFilter Druhý filtr k porovnání.
 */
export const areFiltersEqual = (firstFilter: Filter, secondFilter: Filter): boolean =>
    firstFilter.readVersioned === secondFilter.readVersioned &&
    firstFilter.condition === secondFilter.condition &&
    isArrayShallowEqual(firstFilter.conditionParams ?? EMPTY_ARRAY, secondFilter.conditionParams ?? EMPTY_ARRAY);

/**
 * Vytvoří výsledky agregačních funkcí nastavené na prázdnou hodnotu (null) pro všechny sloupce přítomné v aggregationParams.
 * @param aggregationParams Parametry pro agregaci. Určují, pro které sloupce se vytvoří výsledky.
 */
export const createEmptyFormattedResults = (aggregationParams: IAggregationsParams): FormattedAggregationResults => Object.keys(aggregationParams)
    .reduce((result, columnKey) => {
        result[columnKey] = null;
        return result;
    }, {} as MutableTypedObject<AggregationResult>);
